import fetchClient from '../utils/fetchClient';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';

// Базовые методы API
export const getAllCategories = () => fetchClient.get('/categories/');
export const getCategoriesByUserId = (userId) => fetchClient.get(`/categories/?user_id=${userId}`);
export const getCategoryById = (category_id) => fetchClient.get(`/categories/${category_id}`);
export const createCategory = (data) => fetchClient.post('/categories/', data);
export const updateCategory = (category_id, data) =>
    fetchClient.put(`/categories/${category_id}`, data);
export const deleteCategory = (category_id) => fetchClient.delete(`/categories/${category_id}`);

export const getCategoryGroupsByUserId = (userId) => fetchClient.get(`/category-groups/?user_id=${userId}`);
export const createCategoryGroup = async (data) => {
    const response = await fetchClient.post('/category-groups/', data);
    return response.data;
};
export const updateCategoryGroup = async (groupId, data) => {
    const response = await fetchClient.put(`/category-groups/${groupId}`, data);
    return response.data;
};
export const deleteCategoryGroup = (group_id) => fetchClient.delete(`/category-groups/${group_id}`);

export const getGroupedCategoriesByUserId = (userId) => fetchClient.get(`/categories/grouped/?user_id=${userId}`);

// React Query хуки
export const useCategoriesByUserId = (userId) => {
    return useQuery(
        ['categories', userId],
        () => getCategoriesByUserId(userId),
        {
            staleTime: 1000 * 60 * 5, // 5 минут
            cacheTime: 1000 * 60 * 10, // 10 минут
            enabled: !!userId, // Запрос выполняется только если есть userId
            onSuccess: (data) => {

            },
        }
    );
};

// Создание новой категории
export const useCreateCategory = () => {
    const queryClient = useQueryClient();
    
    return useMutation(
        async ({ name, userId }) => {
            const { data } = await fetchClient.post('/categories/', { name });
            return data;
        },
        {
            onSuccess: (_, { userId }) => {
                queryClient.invalidateQueries(['categories', userId]);
            },
        }
    );
};

// Редактирование категории
export const useUpdateCategory = () => {
    const queryClient = useQueryClient();
    
    return useMutation(
        async (data) => {
            const { id, ...rest } = data;
            const response = await fetchClient.put(`/categories/${id}`, rest);
            return response.data;
        },
        {
            onSuccess: (_, { userId }) => {
                queryClient.invalidateQueries(['categories', userId]);
            },
        }
    );
};

// Удаление категории
export const useDeleteCategory = () => {
    const queryClient = useQueryClient();
    
    return useMutation(
        async ({ id, userId }) => {
            await fetchClient.delete(`/categories/${id}`);
            return id;
        },
        {
            onSuccess: (_, { userId }) => {
                queryClient.invalidateQueries(['categories', userId]);
            },
        }
    );
};

export const useGroupedCategoriesByUserId = (userId) => {
    return useQuery(
        ['groupedCategories', userId],
        () => getGroupedCategoriesByUserId(userId),
        {
            staleTime: 1000 * 60 * 5,
            cacheTime: 1000 * 60 * 10,
            enabled: !!userId,
        }
    );
};

export const useUpdateCategoryGroup = () => {
    const queryClient = useQueryClient();
    const userId = useSelector(state => state.auth.user?.id);

    return useMutation(
        ({ groupId, data }) => updateCategoryGroup(groupId, data),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['groupedCategories', userId]);
                queryClient.invalidateQueries(['categoryGroups', userId]);
            }
        }
    );
};

export const useDeleteCategoryGroup = () => {
    const queryClient = useQueryClient();
    const userId = useSelector(state => state.auth.user?.id);

    return useMutation(
        (groupId) => deleteCategoryGroup(groupId),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['groupedCategories', userId]);
                queryClient.invalidateQueries(['categoryGroups', userId]);
            }
        }
    );
};

// Создание новой группы категорий
export const useCreateCategoryGroup = () => {
    const queryClient = useQueryClient();
    const userId = useSelector(state => state.auth.user?.id);
    
    return useMutation(
        async (data) => {
            const response = await createCategoryGroup(data);
            return response;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['groupedCategories', userId]);
                queryClient.invalidateQueries(['categoryGroups', userId]);
            },
        }
    );
}; 